import API from "..";
import {getStoryBySlug, searchStories} from "../story/requests";
import {categorySlugFromPath} from "../../helpers/URLHelpers";
import {Category} from "./entities";
import {saveSlugsFromRels} from "../../features/stories/interceptors";
import {prop} from "ramda";

const getCategoryBySlug = slug =>
  getStoryBySlug(categorySlugFromPath(slug)).then(Category);

const getArticlesByCategory = ({category, page, pageSize}) =>
  searchStories({category, page, pageSize});

const getSearchCategories = () =>
  API.News.getSearchCategories().then(prop("data")).then(saveSlugsFromRels);

export {getCategoryBySlug, getArticlesByCategory, getSearchCategories};
